import {Backdrop, CircularProgress, Paper, Stack, Typography} from "@mui/material";
import {useSearchParams, useNavigate} from "react-router";
import React, {useEffect, useState} from "react";
import RegionalAccountDisplay from "../components/RegionalAccountDisplay";
import IdentityProviderAccountDisplay from "../components/IdentityProviderAccountDisplay";
import {AccountHealthReport} from "../domain/AccountHealthReport";
import AccountHealthDisplay from "../components/AccountHealthDisplay";
import {SignInListDisplay} from "../components/SignInListDisplay";
import Grid from "@mui/material/Grid2";
import useGASonDemand from "../hooks/useGASonDemand";


export default function LookupCustomerByAccountNumberView() {
    let [searchParams, setSearchParams] = useSearchParams();
    const [region, setRegion]  = useState(searchParams.get('region'));
    const [localUserAccount, setLocalUserAccount]  = useState(searchParams.get('localUserAccount'));
    const {data, error, loading, fetchData} = useGASonDemand();
    const [accountHealthReport, setAccountHealthReport] = useState<AccountHealthReport>();
    const navigate = useNavigate();

    useEffect(() => {
        fetchData(`/account-health?localUserAccount=${localUserAccount}&region=${region}`);
    }, []);

    useEffect(() => {
        if (data) {
            setAccountHealthReport(data);
        }
    }, [data]);

    function handleCancelClicked() {
        navigate("/");
    }

    function identityProviderAccountModified() : void {
        // refetch account
        fetchData(`/account-health?localUserAccount=${localUserAccount}&region=${region}`);
    }

    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}>
                <Stack alignItems='center' spacing={2}>
                    <CircularProgress color="inherit" />
                    <Typography>Finding: {`${region} / ${localUserAccount}`}...</Typography>
                </Stack>
            </Backdrop>

            <Grid container spacing={2}>
                <Grid size={12} sx={{pt: 2}}>
                    <Paper>
                        <AccountHealthDisplay
                                lookupString={`${region} / ${localUserAccount}`}
                                overallHealth={accountHealthReport?.overallHealthRating}
                                componentHealth={accountHealthReport?.accountComponentRating}
                                rules={accountHealthReport?.ruleReports}
                                handleClear={handleCancelClicked}/>
                    </Paper>
                </Grid>
                <Grid size={12}>
                    <Paper sx={{pb: 2}}>
                        <RegionalAccountDisplay
                            regionalAccount={accountHealthReport?.foundAccount}
                            children={accountHealthReport?.foundChildren}
                            membership={accountHealthReport?.foundMembership}
                            products={accountHealthReport?.foundProducts}
                            bonusEntitlements={accountHealthReport?.foundBonusEntitlements}/>
                    </Paper>
                </Grid>
                <Grid size={12}>
                    <Paper>
                        <IdentityProviderAccountDisplay identityProviderAccount={accountHealthReport?.foundAzureAccounts} handleAccountModified={identityProviderAccountModified}/>
                    </Paper>
                </Grid>
                <Grid size={12}>
                    <Paper>
                        <SignInListDisplay accountGuid={accountHealthReport?.foundAzureAccounts?.globalId} />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}